import { render, staticRenderFns } from "./CriarCobranca.vue?vue&type=template&id=7b9eaa96&scoped=true"
import script from "./CriarCobranca.vue?vue&type=script&lang=ts"
export * from "./CriarCobranca.vue?vue&type=script&lang=ts"
import style0 from "./CriarCobranca.vue?vue&type=style&index=0&id=7b9eaa96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9eaa96",
  null
  
)

export default component.exports